import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, Users, FileSignature, Package, Car, 
  Phone, Bell, Settings, BookOpen, X, ShieldCheck, ClipboardList
} from 'lucide-react';
import logo from "../../assets/Sankrutilogo.jpeg";
import styles from './SecuritySidebar.module.css';

const securityMenuGroups = [
  {
    title: 'MAIN',
    items: [
      { name: 'Dashboard', path: '/security', icon: LayoutDashboard, exact: true },
    ]
  },
  {
    title: 'OPERATIONS',
    items: [
      { name: 'Visitor Management', path: '/security/visitors', icon: Users },
      { name: 'Delivery Entries', path: '/security/deliveries', icon: Package },
      { name: 'Vehicle Entries', path: '/security/vehicles', icon: Car },
      { name: 'Gate Check-In/Out', path: '/security/gate-pass', icon: FileSignature },
      { name: 'Patrolling Logs', path: '/security/patrolling', icon: ShieldCheck },
      { name: 'Worker Attendance', path: '/security/attendance', icon: ClipboardList },
    ]
  },
  {
    title: 'COMMUNITY',
    items: [
      { name: 'Resident Directory', path: '/security/directory', icon: BookOpen },
    ]
  },
  {
    title: 'RESOURCES',
    items: [
      { name: 'Emergency Contacts', path: '/security/emergency', icon: Phone },
      { name: 'Notifications', path: '/security/notifications', icon: Bell },
    ]
  },
  {
    title: 'ACCOUNT',
    items: [
      { name: 'Settings', path: '/security/settings', icon: Settings },
    ]
  }
];

const SecuritySidebar = ({ mobileOpen = false, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = (path) => {
    navigate(path);
    if (onClose) onClose();
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <>
      {mobileOpen && <div className={styles.overlay} onClick={onClose} />}
      <aside className={`${styles.sidebar} ${mobileOpen ? styles.open : ""}`}>
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close sidebar"
        >
          <X size={20} />
        </button>
        <div className={styles.logoArea} onClick={() => handleNavigate('/')} style={{ cursor: 'pointer' }} title="Go to Website Home">
        <img src={logo} alt="Sanskriti Logo" className={styles.logoImage} />
      </div>
      
      <nav className={styles.navLinks}>
        {securityMenuGroups.map((group, groupIndex) => (
          <div key={groupIndex} className={styles.navGroup}>
            {group.title && <div className={styles.groupTitle}>{group.title}</div>}
            
            {group.items.map((link) => {
              const Icon = link.icon;
              const isActive = location.pathname === link.path;

              return (
                <button
                  key={link.path}
                  className={`${styles.navItem} ${isActive ? styles.active : ""}`}
                  onClick={() => handleNavigate(link.path)}
                >
                  <Icon className={styles.icon} size={16} strokeWidth={2} />
                  <span>{link.name}</span>
                </button>
              );
            })}
          </div>
        ))}
      </nav>
    </aside>
    </>
  );
};

export default SecuritySidebar;
